/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Feature5Inputs */

const ja_playdata_pricing_feature5 = /** @type {(inputs: Playdata_Pricing_Feature5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャンネル別の平均同時視聴者数`)
};

const en_playdata_pricing_feature5 = /** @type {(inputs: Playdata_Pricing_Feature5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Average concurrent viewers by channel`)
};

/**
* | output |
* | --- |
* | "Average concurrent viewers by channel" |
*
* @param {Playdata_Pricing_Feature5Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_feature5 = /** @type {((inputs?: Playdata_Pricing_Feature5Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Feature5Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_feature5(inputs)
	return en_playdata_pricing_feature5(inputs)
});